import React from "react";
import { TableRow, TableCell, Button} from "@material-ui/core";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";

const Issue = (props) => {
  const issue = props.issue;
  const index = props.index;
  const customization = props.customization;

  return (
    <TableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell>
        <Link
          onClick={() => {
            props.users.isAuthenticated
            ? props.history.push(`/issue-tracker/issues/view/${issue.id}`)
            : props.setAlertOpen(true);
          }}
          style={{ color: "blue", fontSize: "16px" }}
          to="#"
        >
          {issue.description}
        </Link>
      </TableCell>
      {
        customization.severity
          ? <TableCell>{issue.severity}</TableCell>
          : null    
      }
      {
        customization.status
          ? <TableCell>{issue.status}</TableCell>
          : null    
      }
      {
        customization.createdDate
          ? <TableCell>{issue.createdDate}</TableCell>
          : null    
      }
      {
        customization.lastUpdated
          ? <TableCell>{issue.lastUpdated}</TableCell>
          : null    
      }
      {
        customization.resolvedDate
          ? <TableCell>{issue.resolvedDate ? issue.resolvedDate : "Not resolved"}</TableCell>
          : null    
      }
      {
        customization.lastUpdatedBy
          ? <TableCell>{issue.lastUpdatedByName}</TableCell>
          : null    
      }
      {
        customization.loggedBy
          ? <TableCell>{issue.loggedByName}</TableCell>
          : null    
      }
      <TableCell>
        <Button 
          onClick={() => {
            props.users.isAuthenticated 
            ? props.history.push(`/issue-tracker/issues/edit/${issue.id}`)
            : props.setAlertOpen(true);
          }}
          size="small" 
          color="primary" 
          startIcon={<EditIcon />}
        >
          Edit
        </Button>
      </TableCell>
      <TableCell>
        <Button
          onClick={() => {
            props.users.isAuthenticated
            ? window.confirm("Are you sure you want to delete this issue?")
            ? props.actions.deleteIssue(issue) : console.log()
            : props.setAlertOpen(true);
          }}
          size="small" 
          color="secondary"
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      </TableCell>
    </TableRow>
  );
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Issue));
